import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { FormField } from '../formField';
import styles from './ManualAddress.module.css';
import messages from './ManualAddress.messages';
import { getCountry } from '../../iwIntlProvider/CountryProvider';
import { supportsAutoAddress } from '../../helpers/address';

export function ManualAddress({ addressIndex = 0, onManualAddressToggle }) {
    return (
        <div data-testid="manual-address" className={styles.ManualAddress}>
            <div className={styles.twoColumnWrapper}>
                <FormField
                    data-testid="house-number-input"
                    className={classNames(
                        styles.houseNumberField,
                        'fs-exclude'
                    )}
                    name={`addresses[${addressIndex}].house_number`}
                    label={<FormattedMessage {...messages.houseNumber} />}
                />

                <BuildingDetails addressIndex={addressIndex} />
            </div>

            <FormField
                data-testid="street-line-one-input"
                name={`addresses[${addressIndex}].street_line_1`}
                label={<FormattedMessage {...messages.streetLineOne} />}
                className="fs-exclude"
            />

            <FormField
                name={`addresses[${addressIndex}].street_line_2`}
                label={<FormattedMessage {...messages.streetLineTwo} />}
                className="fs-exclude"
            />

            <div className={styles.twoColumnWrapper}>
                <FormField
                    data-testid="town-input"
                    name={`addresses[${addressIndex}].town`}
                    label={<FormattedMessage {...messages.town} />}
                    className="fs-exclude"
                />
                <FormField
                    data-testid="post-code-input"
                    className={classNames(styles.postcodeField, 'fs-exclude')}
                    name={`addresses[${addressIndex}].postcode`}
                    label={<FormattedMessage {...messages.postcode} />}
                />
            </div>

            {supportsAutoAddress() ? (
                <div
                    className={styles.manualAddressToggle}
                    onClick={() => onManualAddressToggle(addressIndex)}
                >
                    <FormattedMessage {...messages.searchForMyAddress} />
                </div>
            ) : null}
        </div>
    );
}

function BuildingDetails({ addressIndex }) {
    switch (getCountry()) {
        case 'UK':
            return (
                <FormField
                    className={classNames(styles.houseNameField, 'fs-exclude')}
                    name={`addresses[${addressIndex}].house_name`}
                    label={<FormattedMessage {...messages.houseName} />}
                />
            );
        case 'DE':
        default:
            return null;
    }
}
